module.exports = {
  setup: {
    actionBtn: "Save",
    action: "insurance",
    pages: [
      {
        title: "Underwriter Details",
        subtitle: "Configure Underwriter Information",
        forms: [
          {
            type: "text",
            form_type: "text",
            label: "Licence/IRA Number",
            model: "licence_number",
            validation: "required|min:2|max:50",
            class: "col-12 col-md-6",
          },
          {
            type: "text",
            form_type: "text",
            label: "Name",
            model: "name",
            validation: "required|min:2|max:100",
            class: "col-12 col-md-6",
          },
          {
            type: "text", 
            form_type: "text", 
            label: "Category",
            model: "category",
            validation: "required|min:2|max:100", 
            class: "col-12 col-md-6",
            placeholder: "Enter category",
          },
          {
            type: "text",
            form_type: "email",
            label: "Emails",
            model: "emails",
            validation: "required|email",
            class: "col-12 col-md-6",
          },
          {
            type: "text",
            form_type: "text",
            label: "Classes",
            model: "classes",
            validation: "required|min:2|max:150",
            class: "col-12 col-md-6",
          },
          {
            type: "text",
            form_type: "text",
            label: "Contacts",
            model: "contacts",
            validation: "required|min:2|max:150",
            class: "col-12 col-md-6",
          },
        ],
      },
    ],
  },
  table: {
    icon: "icon-suit",
    title: "Underwriter List",
    subtitle: "List of Underwriters",
    table_fields: [
      { name: "Licence/IRA Number", align: "c" },
      { name: "Name", align: "c" },
      { name: "Category", align: "c" },
      { name: "Emails", align: "c" },
      { name: "Classes", align: "c" },
      { name: "Contacts", align: "c" },
      { name: "Actions", align: "c" },
    ],
    searchFields: [
      "licence_number",
      "name",
      "category",
      "emails",
      "classes",
      "contacts",
    ],
    rowData: [
      { type: "text", field: "licence_number", class: "center" },
      { type: "text", field: "name", class: "center" },
      { type: "text", field: "category", class: "center" },
      { type: "text", field: "emails", class: "center" },
      { type: "text", field: "classes", class: "center" },
      { type: "text", field: "contacts", class: "center" },
      {
        type: "action",
        field: "name",
        class: "center",
        actions: [
          {
            type: "menu",
            title: "Edit",
            event: "underwriter:edit",
            icon: "edit-3",
            params: [{ key: "underwriter", field: "*" }],
          },
          {
            type: "menu",
            title: "View",
            event: "underwriter:view",
            icon: "eye",
            params: [{ key: "licence_number", field: "*" }],
          },
          {
            type: "menu",
            title: "Delete",
            event: "underwriter:delete",
            icon: "delete",
            params: [{ key: "licence_number", field: "*" }],
          },
        ],
      },
    ],
  },
  wizard: {
    upload_underwritters: {
      action: "upload_underwritters",
      actionBtn: "Save",
      pages: [],
    },
  },
  init: function () {
    console.log("insurance.model.js: Model initialized", this);
    console.log("insurance.model.js: Checking wizard property", this.wizard);
    return this;
  },
};
